import { render, staticRenderFns } from "./gl-info-tag.vue?vue&type=template&id=631851dd"
import script from "./gl-info-tag.vue?vue&type=script&lang=js"
export * from "./gl-info-tag.vue?vue&type=script&lang=js"
import style0 from "./gl-info-tag.vue?vue&type=style&index=0&id=631851dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports